export default "__VITE_ASSET__IayvMV2O__";